// This file can be replaced during build by using the `fileReplacements` array.
export const environment = {
  production: false,
  //apiUrl: 'http://localhost/peluqueriabackend/public/api/',
  apiUrl: 'https://karlasalonbackend.sergioluisalvarez.com/public/api/',
  usu_id: '1',
  eqt_id: '1',
  eqc_id: '1'
};
